/* eslint-disable canvas/no-swallow-errors-in-catch */
import { logError } from '@databases/logs';
import { useCallback, useEffect, useState } from 'react';

import { useCoordinationClient } from './useCoordinationClient';

export const useConditionalCoordination = (
  messageId: string,
  enabled = true // refers to the ff value
): [boolean, (force?: boolean) => Promise<void>] => {
  const [started, setStarted] = useState(false);

  const coordinationClient = useCoordinationClient();

  useEffect(() => {
    if (!coordinationClient) {
      return;
    }

    if (!enabled) {
      return;
    }

    (async () => {
      try {
        const messageStarted = await coordinationClient.start(messageId);

        if (messageStarted) {
          setStarted(true);
        }
      } catch (error: unknown) {
        if (error instanceof Error) {
          logError('Start EP coordination error: ', error);
        }
      }
    })();
  }, [coordinationClient, enabled, messageId]);

  const stop = useCallback(
    async (force = false) => {
      if (!coordinationClient) {
        return;
      }

      if (!force && !started) {
        return;
      }

      try {
        await coordinationClient.stop(messageId);
      } catch (error: unknown) {
        if (error instanceof Error) {
          logError('Stop EP coordination error: ', error);
        }
      }
    },
    [started, coordinationClient, messageId]
  );

  return [started, stop];
};
